import { render, staticRenderFns } from "./VenuesListView.vue?vue&type=template&id=cc2ad15a&"
import script from "./VenuesListView.vue?vue&type=script&lang=js&"
export * from "./VenuesListView.vue?vue&type=script&lang=js&"
import style0 from "./VenuesListView.vue?vue&type=style&index=0&id=cc2ad15a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports